import React from "react";
import { withTranslation } from "react-i18next";
import { useLocation } from "react-router";
import SubHeaderWrapper from "./subHeader.style";
import user from "../../assets/images/icons/icon_user.svg";
import Stepper from "../Stepper/Stepper";
import propTypes from 'prop-types';

const SubHeader = (props) => {
  const location = useLocation();
  const activeIndex = props.steps.findIndex((ele) => ele.link === location.pathname || (Array.isArray(ele.link) && ele.link.includes(location.pathname)));

  const getStepperStatus = (index, activeIndex) => {
    if (index < activeIndex) {
      return "active";
    }
    if (index === activeIndex) {
      return "next";
    }
    return "pending";
  }

  const steps = props.steps.map((ele, index) => {
    return {
      ...ele,
      status: getStepperStatus(index, activeIndex),
      title: props.i18n.t(ele.title)
    }
  });




  return (
    <SubHeaderWrapper>
      <div className={"steps-wrapper"}>
        <div className="container">
          <div className="row">
            <div className="col-md-4 mb-3" style={{ "textAlign": "initial" }}>
              <div className="user-wrapper">
                <div className="logo-wrapper">
                  <img src={user} alt="" />
                </div>
                <div className="user-details">
                  <p className="dark-color">{props.i18n.t("WELCOME")}</p>
                  {!props.hideUsername && <p> {props.username}</p>}
                </div>
              </div>
            </div>
            <div className={steps.length <= 2 ? "col-md-5" : "col-md-2"}>
            </div>
            <div className={steps.length <= 2 ? "col-md-3" : "col-md-6"}>
              <Stepper steps={steps} />
            </div>
          </div>
        </div>
      </div>
    </SubHeaderWrapper>
  );
};

SubHeader.propTypes = propTypes.exact({
  steps: propTypes.arrayOf(propTypes.exact({
    id: propTypes.number,
    title: propTypes.string,
    link: propTypes.any,
    status: propTypes.oneOf(['active', 'next', 'pending'])
  })).isRequired,
  username: propTypes.string,
  hideUsername: propTypes.bool
}).isRequired
export default withTranslation()(SubHeader);
